import { render, staticRenderFns } from "./ImportFile.vue?vue&type=template&id=576ec8d6&scoped=true"
import script from "./ImportFile.vue?vue&type=script&lang=ts"
export * from "./ImportFile.vue?vue&type=script&lang=ts"
import style0 from "./ImportFile.vue?vue&type=style&index=0&id=576ec8d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576ec8d6",
  null
  
)

export default component.exports